export default __webpack_public_path__ + "static/media/luna.d2e30231.png";